import { Button, spacing, Text } from "@minuthq/meatball-ui-react"
import { useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

export function NotFound404() {
  const { tPlaceholder } = useTranslate()

  return (
    <PageLayout
      title={tPlaceholder("Page not found")}
      description={tPlaceholder(
        "The page you're looking for doesn't exist or has moved."
      )}
      footer={<Footer />}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    />
  )
}

function Footer() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()

  return (
    <Text variant="bodyS" color="secondary" marginBottom={spacing.XS}>
      <Button
        variant="minimal"
        color="neutral"
        size="small"
        onClick={() => {
          void navigate({ to: "/login" })
        }}
      >
        {tPlaceholder("Back to login")}
      </Button>
    </Text>
  )
}
